export default class Video {
    constructor(element) {
        this.element = element
        this.video = element.querySelector("video")

        this.video.addEventListener('ended', () => this.addVideoOverlay())
        this.video.addEventListener('click', () => this.toggleVideo())
    }

    toggleVideo() {
        if (this.video.paused || this.video.ended) {
            this.video.play()
            this.removeVideoOverlay()
        } else {
            this.video.pause()
            this.addVideoOverlay()
        }
    }

    addVideoOverlay() {
        this.element.classList.remove("playing");
    }

    removeVideoOverlay() {
        this.element.classList.add("playing");
    }
}
